export function dateToString(fecha: Date): string {
  const dateFormated =
    fecha?.getDate().toString().padStart(2, "0") +
    "/" +
    (fecha?.getMonth() + 1).toString().padStart(2, "0") +
    "/" +
    fecha?.getFullYear();
  return dateFormated;
}

export const getLocalDate = (paramDate: Date) => {
  return paramDate.toLocaleString("es-AR", {
    timeZone: "America/Cordoba",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
};

export const timeToString = (fecha: Date) => {
  const hour = fecha.getHours()
  const minutes =fecha.getMinutes()
  return `${hour < 10 ? "0" + hour : hour}:${minutes < 10 ? "0" + minutes : minutes}`
}

export const generateCurrentTime = () => {
  const date = new Date();
  const currentDate = dateToString(date) 
  const currentHour = timeToString(date);
  return {
    currentDate,
    currentHour
  }
}